import { Controller } from '@hotwired/stimulus';

import useAlgoliaClientInsights from '../../stimulus-composables/algolia/client-insights';

export default class extends Controller {
    static values = {
        context: String,
    };

    connect() {
        useAlgoliaClientInsights(this, this.contextValue);
    }
}
